import { useDispatch, useSelector } from 'react-redux';
import { toggleShippingPdfPrices } from 'reducers/shippingPdfPricesSlice';

export default function useShippingPdfPrices() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.loginUser.useraccount_id);
  const roles = useSelector(state => state.loginUser.roles);
  const hidden = useSelector(state => state.shippingPdfPrices?.hiddenByUser?.[String(user)] ?? false);
  const canViewPrices = (roles ?? []).some(role =>
    (role.listmenus ?? []).some(menu => menu.name === 'View_Prices_Shipping'));
  return {
    canViewPrices,
    showPrices: canViewPrices && !hidden,
    togglePrices: () => dispatch(toggleShippingPdfPrices(user)),
  };
}
